{
  "type": "module",
  "name": "outlaw-practice-client",
  "version": "7.0.5",
  "private": true,
  "scripts": {
    "analyze": "source-map-explorer 'build/static/js/*.js'",
    "postinstall": "patch-package",
    "start": "vite --force",
    "test": "vitest",
    "test:ui": "vitest --ui --watch",
    "test:run": "vitest run",
    "test:fast": "vitest run -c vitest.config.fast.ts",
    "test:firefox": "vitest run -c vitest.config.firefox.ts",
    "test:compat": "vitest run -c vitest.config.compat.ts",
    "test:all": "npm run test:fast && npm run test:firefox",
    "test:batched": "./scripts/test-batched.sh fast",
    "test:batched:firefox": "./scripts/test-batched.sh firefox",
    "test:batched:all": "./scripts/test-batched.sh fast && ./scripts/test-batched.sh firefox",
    "test:batched:guard": "./scripts/test-batched.guard.test.sh",
    "test:install-deps": "./scripts/install-deps.test.sh",
    "test:mobile:iphone14pro": "MOBILE_DEVICE=iphone14pro vitest run -c vitest.config.mobile.iphone14pro.ts",
    "test:mobile:iphone14promax": "MOBILE_DEVICE=iphone14promax vitest run -c vitest.config.mobile.iphone14promax.ts",
    "test:mobile:s22": "MOBILE_DEVICE=s22 vitest run -c vitest.config.mobile.s22.ts",
    "test:mobile:s22plus": "MOBILE_DEVICE=s22plus vitest run -c vitest.config.mobile.s22plus.ts",
    "test:mobile:ipadpro11": "MOBILE_DEVICE=ipadpro11 vitest run -c vitest.config.mobile.ipadpro11.ts",
    "test:mobile:all": "npm run test:mobile:iphone14pro && npm run test:mobile:iphone14promax && npm run test:mobile:s22 && npm run test:mobile:s22plus && npm run test:mobile:ipadpro11",
    "test:coverage": "vitest run --coverage",
    "test:entities": "vitest run -c vitest.config.entities-coverage.ts",
    "test:coverage:idbd": "vitest run -c vitest.config.idbd-coverage.ts",
    "test:coverage:worker": "vitest run -c vitest.config.worker-coverage.ts",
    "test:coverage:dateutils": "vitest run -c vitest.config.dateutils-coverage.ts",
    "test:watch": "vitest watch",
    "test:watch:fast": "vitest watch -c vitest.config.fast.ts",
    "test:e2e": "npx playwright test && npx playwright show-report",
    "test:e2e:cards": "npx playwright test cards/ --project=chromium",
    "test:e2e:deep-links": "rm -f e2e/deep-links.spec.js && npx playwright test deep-links --project=chromium",
    "test:e2e-ui": "npx playwright test --ui",
    "codegen": "npx playwright codegen --load-storage=e2e/.auth/user.json --ignore-https-errors -o e2e/_recording.ts https://localhost:3000",
    "build": "NODE_OPTIONS=--max-old-space-size=32768 rm -f ./build/assets/* && /opt/homebrew/bin/tsc --noEmit && vite build --mode production",
    "preview": "vite preview --port 3000",
    "typecheck:strictnull": "/opt/homebrew/bin/tsc --noEmit -p tsconfig.strictnull.json",
    "lint": "npx eslint -c eslint/eslint.config.mjs --quiet",
    "lint:css": "npx eslint -c eslint/eslint-css.config.mjs --quiet --format $(pwd)/eslint/stylish-relative.js",
    "lint:react": "npx eslint -c eslint/eslint-react.config.mjs --quiet --format $(pwd)/eslint/stylish-relative.js",
    "lint:react-refresh": "npx eslint -c eslint/eslint-react-refresh.config.mjs --quiet --format $(pwd)/eslint/stylish-relative.js",
    "lint:hooks": "npx eslint -c eslint/eslint-hooks.config.mjs --quiet --format $(pwd)/eslint/stylish-relative.js",
    "lint:redux": "npx eslint -c eslint/eslint-redux.config.mjs --quiet --format $(pwd)/eslint/stylish-relative.js",
    "lint:security": "npx eslint -c eslint/eslint-security.config.mjs --quiet --format $(pwd)/eslint/stylish-relative.js",
    "lint:a11y": "npx eslint -c eslint/eslint-jsx-a11y.config.mjs --quiet --format $(pwd)/eslint/stylish-relative.js",
    "lint:webapi": "NODE_OPTIONS=--max-old-space-size=8192 npx eslint -c eslint/eslint-webapi.config.mjs --quiet --format $(pwd)/eslint/stylish-relative.js",
    "lint:invoice-association": "npx eslint -c eslint/eslint-invoice-association.config.mjs --quiet --format $(pwd)/eslint/stylish-relative.js"
  },
  "dependencies": {
    "@outlaw/signin": "file:../../../shared/signin",
    "@air/react-drag-to-select": "^5.0.11",
    "@auth0/auth0-react": "^2.27.0",
    "@auth0/auth0-spa-js": "^2.27.0",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@files-ui/react": "^1.2.5",
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/free-brands-svg-icons": "^7.2.0",
    "@fortawesome/pro-duotone-svg-icons": "^7.2.0",
    "@fortawesome/pro-light-svg-icons": "^7.2.0",
    "@fortawesome/pro-regular-svg-icons": "^7.2.0",
    "@fortawesome/pro-solid-svg-icons": "^7.2.0",
    "@fortawesome/react-fontawesome": "^3.3.1",
    "@fullcalendar/core": "^6.1.20",
    "@fullcalendar/daygrid": "^6.1.20",
    "@fullcalendar/interaction": "^6.1.20",
    "@fullcalendar/list": "^6.1.20",
    "@fullcalendar/react": "^6.1.20",
    "@fullcalendar/timegrid": "^6.1.20",
    "@grafana/faro-web-sdk": "^2.7.1",
    "@mui/icons-material": "^9.1.0",
    "@mui/material": "^9.1.0",
    "@mui/x-date-pickers": "^9.4.0",
    "@mui/x-tree-view": "^9.4.0",
    "@nivo/axes": "^0.99.0",
    "@nivo/bar": "^0.99.0",
    "@nivo/pie": "^0.99.0",
    "@nivo/sankey": "^0.99.0",
    "@nivo/scatterplot": "^0.99.0",
    "@nivo/swarmplot": "^0.99.0",
    "@reduxjs/toolkit": "^2.12.0",
    "@rrweb/replay": "2.0.1",
    "@sroussey/parse-address": "^2.4.2",
    "@tanstack/react-query": "^5.101.0",
    "@ua-parser-js/pro-business": "^2.0.9",
    "browserslist": "^4.28.2",
    "buffer": "^6.0.3",
    "chroma-js": "^3.2.0",
    "comlink": "^4.4.2",
    "date-fns": "^4.2.1",
    "date-fns-tz": "^3.2.0",
    "debounce": "^3.0.0",
    "dexie": "^4.4.2",
    "dompurify": "^3.4.8",
    "eml-parse-js": "^1.2.0-beta.1",
    "fast-deep-equal": "^3.1.3",
    "framer-motion": "^12.39.0",
    "fuse.js": "^7.4.2",
    "http-status-codes": "^2.3.0",
    "immer": "^11.1.8",
    "jszip": "^3.10.1",
    "libphonenumber-js": "^1.13.6",
    "localforage": "^1.10.0",
    "lz4-wasm": "^0.9.2",
    "marked": "^18.1.0",
    "moment": "^2.30.1",
    "oauth4webapi": "3.8.8",
    "owasp-password-strength-test": "^1.3.0",
    "oxide.ts": "^1.1.0",
    "p-wait-for": "^6.0.0",
    "pako": "^2.1.0",
    "papaparse": "^5.5.3",
    "parse-full-name": "^1.2.6",
    "pdfmake": "0.3.11",
    "performance-now": "^2.1.0",
    "qrcode": "^1.5.4",
    "quill-image-compress": "^2.0.3",
    "react": "^19.2.7",
    "react-calendar": "^6.0.1",
    "react-conditional-components-renderer": "^1.1.0",
    "react-date-range": "^2.0.1",
    "react-dom": "^19.2.7",
    "react-error-boundary": "^6.1.1",
    "react-grid-layout": "^2.2.3",
    "react-image": "^4.1.0",
    "react-intersection-observer": "^10.0.3",
    "react-pdf": "^10.4.1",
    "react-phone-number-input": "^3.4.16",
    "react-quill-new": "^3.8.3",
    "react-redux": "^9.3.0",
    "react-select": "^5.10.2",
    "react-tabs": "^6.1.1",
    "react-toastify": "^11.1.0",
    "react-tooltip": "^6.0.7",
    "react-virtualized-auto-sizer": "^2.0.3",
    "redux": "^5.0.1",
    "redux-saga": "^1.4.2",
    "rrweb": "2.0.1",
    "rrweb-player": "2.0.1",
    "safe-buffer": "^5.2.1",
    "socket.io-client": "^4.8.3",
    "spark-md5": "^3.0.2",
    "string-strip-html": "^13.5.3",
    "stripe": "^22.0.1",
    "uuid": "^14.0.0",
    "validator": "^13.15.35",
    "wouter": "^3.9.0",
    "zustand": "^5.0.13",
    "zustand-x": "^6.2.1"
  },
  "devDependencies": {
    "@babel/preset-env": "^7.29.0",
    "@babel/preset-react": "^7.28.5",
    "@babel/preset-typescript": "^7.28.5",
    "@emotion/babel-plugin": "^11.13.5",
    "@eslint/css": "^1.3.0",
    "@playwright/test": "^1.63.0",
    "@types/chroma-js": "^3.1.2",
    "@types/debounce": "^3.0.0",
    "@types/dompurify": "^3.0.5",
    "@types/google.maps": "^3.65.1",
    "@types/owasp-password-strength-test": "^1.3.2",
    "@types/pako": "^2.0.4",
    "@types/parse-full-name": "^1.2.5",
    "@types/pdfmake": "^0.3.0",
    "@types/qrcode": "^1.5.6",
    "@types/react": "^19.2.17",
    "@types/react-dom": "^19.2.3",
    "@types/react-grid-layout": "^1.3.6",
    "@types/react-redux": "^7.1.34",
    "@types/spark-md5": "^3.0.5",
    "@types/validator": "^13.15.10",
    "@typescript-eslint/eslint-plugin": "^8.60.1",
    "@typescript-eslint/parser": "^8.60.1",
    "@vitejs/plugin-react": "^6.0.2",
    "@vitest/browser-playwright": "^4.1.11",
    "@vitest/coverage-v8": "^4.1.11",
    "@vitest/ui": "^4.1.11",
    "@wdio/appium-service": "^9.23.3",
    "@wdio/cli": "^9.23.3",
    "@wdio/local-runner": "^9.23.3",
    "@wdio/mocha-framework": "^9.23.3",
    "@wdio/spec-reporter": "^9.23.3",
    "appium": "^3.2.0",
    "appium-xcuitest-driver": "^11.9.1",
    "babel-plugin-react-compiler": "^1.0.0",
    "eslint": "^10.4.1",
    "eslint-import-resolver-typescript": "^4.4.5",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-playwright": "^2.10.4",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-compiler": "^19.1.0-rc.2",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-react-redux": "^4.2.2",
    "eslint-plugin-react-refresh": "^0.5.2",
    "eslint-plugin-react-web-api": "^5.8.16",
    "eslint-plugin-security": "^4.0.0",
    "fake-indexeddb": "^6.2.5",
    "jsdom": "^29.1.1",
    "less": "^4.6.4",
    "lightningcss": "^1.32.0",
    "patch-package": "8.0.1",
    "playwright": "^1.63.0",
    "rollup-plugin-visualizer": "^7.0.1",
    "terser": "^5.46.0",
    "typescript-eslint": "^8.60.1",
    "vite": "^8.0.16",
    "vite-plugin-comlink": "^5.3.0",
    "vite-plugin-eslint": "^1.8.1",
    "vite-plugin-pwa": "^1.3.0",
    "vite-plugin-svgr": "^5.2.0",
    "vite-plugin-wasm": "^3.6.0",
    "vitest": "^4.1.11",
    "vitest-browser-react": "^2.2.0",
    "zod": "^4.3.6"
  },
  "overrides": {
    "zod-validation-error": "^4.0.2",
    "eslint-plugin-jsx-a11y": {
      "eslint": "$eslint"
    },
    "eslint-plugin-react": {
      "eslint": "$eslint"
    },
    "eslint-plugin-react-redux": {
      "eslint": "$eslint"
    },
    "eslint-plugin-import": {
      "eslint": "$eslint"
    }
  }
}
